import React from 'react'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { DiscordIcon, FormikField } from 'shared'
import ProfileFormWrapper from 'components/wrappers/ProfileFormWrapper'

import { TikTokIcon, InstagramIcon } from 'shared'

const useStyles = makeStyles((theme) => ({
  iconContainer: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    marginRight: 24,
    padding: '0 20px',
    display: 'flex',
    maxHeight: 64,
  },
}))

const ProfileFormSocial = () => {
  const classes = useStyles()

  return (
    <ProfileFormWrapper
      title="Social media"
      stepDescription="Enter your social media handles."
    >
      <Grid container flexWrap="nowrap" sx={{ mb: 3 }}>
        <Grid
          alignItems="center"
          justifyContent="center"
          className={classes.iconContainer}
        >
          <InstagramIcon width={24} height={24} />
        </Grid>
        <FormikField
          name="instagramHandle"
          label="Instagram"
          placeholder="Enter instagram"
        />
      </Grid>
      <Grid container flexWrap="nowrap" sx={{ mb: 3 }}>
        <Grid
          alignItems="center"
          justifyContent="center"
          className={classes.iconContainer}
        >
          <DiscordIcon width={24} height={24} />
        </Grid>
        <FormikField
          name="discordHandle"
          label="Discord"
          placeholder="Enter discord"
        />
      </Grid>
      <Grid container flexWrap="nowrap">
        <Grid
          alignItems="center"
          justifyContent="center"
          className={classes.iconContainer}
        >
          <TikTokIcon width={24} height={24} />
        </Grid>
        <FormikField
          name="tiktokHandle"
          label="TikTok"
          placeholder="Enter tiktok"
        />
      </Grid>
    </ProfileFormWrapper>
  )
}

export default ProfileFormSocial
